import { humanRigs, type HumanProportions, type HumanRigId } from './human.js';
import { ELF_FACE_DEFAULT, elfFaceShape, elfSkull, resolveElfFace, type ElfFaceMorph } from './elf-face.js';

export type ElfRigId = 'elf-male' | 'elf-female';
export interface ElfProportions extends HumanProportions { faceMorph: ElfFaceMorph }
export const ELF_RIG_VERSION = 1;
function proportions(id: ElfRigId, motionRig: HumanRigId): ElfProportions {
  const p = structuredClone(humanRigs[motionRig]);
  const faceMorph = { ...ELF_FACE_DEFAULT }, face = elfFaceShape(faceMorph, motionRig);
  return { ...p, id, bodyMorph: { breadth: .9, depth: .9, limbWidth: .87, armLength: 1.06, legLength: 1.08, torsoLength: 1, neckLength: 1.18, headSize: .97, handSize: .95 },
    muscularity: .12, muscleDefinition: .55, fatness: 0,
    faceMorph, face, skull: elfSkull(faceMorph, motionRig), faceNeutral: { width: 1, length: 1, noseSize: 1, eye: face.eye }, headMeshCell: .0035 };
}
export const elfRigs: Record<ElfRigId, ElfProportions> = {
  'elf-male': proportions('elf-male', 'human-male'), 'elf-female': proportions('elf-female', 'human-female'),
};
export function elfProportions(rig = 'elf-male'): ElfProportions {
  if (!(rig in elfRigs)) throw new Error(`No Elf morph registered for rig '${rig}'.`);
  return elfRigs[rig as ElfRigId];
}
export function morphElfProportions(source: ElfProportions, faceId = 'standard'): ElfProportions {
  const faceMorph = resolveElfFace(source.faceMorph, faceId), face = elfFaceShape(faceMorph, source.motionRig);
  return { ...source, faceMorph, face, skull: elfSkull(faceMorph, source.motionRig),
    faceNeutral: { width: 1, length: 1, noseSize: 1, eye: face.eye }, headCacheKey: `${source.id}:${faceId}:${JSON.stringify(faceMorph)}` };
}
export const elfStandardHeight = (rig: string) => rig === 'elf-female' ? 1.85 : 1.95;
